import {NotifyHelper} from "../../../helpers/toast";
import {generateActionForKey, generateActions} from "../generateActions";
import {eDmLoaiThuTuyenSinhActionsObj} from "./../../action-types/category/IDmLoaiThuTuyenSinhActions";

export const loaiThuTuyenSinhActions = {
    ...generateActions(eDmLoaiThuTuyenSinhActionsObj, "LOAI_THU_TUYEN_SINH"),
    ...generateActionForKey(
        eDmLoaiThuTuyenSinhActionsObj,
        "LOAI_THU_TUYEN_SINH",
        "SAVE_SUCCESS",
        () => {
            NotifyHelper.Success("Đã cập nhật");
        }
    ),
    ...generateActionForKey(
        eDmLoaiThuTuyenSinhActionsObj,
        "LOAI_THU_TUYEN_SINH",
        "SAVE_ERROR",
        (m: string) => {
            NotifyHelper.Error(m);
        }
    ),
    ...generateActionForKey(
        eDmLoaiThuTuyenSinhActionsObj,
        "LOAI_THU_TUYEN_SINH",
        "DELETE_SUCCESS",
        () => {
            NotifyHelper.Success("Đã xóa");
        }
    ),
    ...generateActionForKey(
        eDmLoaiThuTuyenSinhActionsObj,
        "LOAI_THU_TUYEN_SINH",
        "DELETE_ERROR",
        (m: string) => {
            NotifyHelper.Error(m);
        }
    ),
    ...generateActionForKey(
        eDmLoaiThuTuyenSinhActionsObj,
        "LOAI_THU_TUYEN_SINH",
        "DELETE_MANY_SUCCESS",
        () => {
            NotifyHelper.Success("Đã xóa");
        }
    ),
    ...generateActionForKey(
        eDmLoaiThuTuyenSinhActionsObj,
        "LOAI_THU_TUYEN_SINH",
        "DELETE_MANY_ERROR",
        (m: string) => {
            NotifyHelper.Error(m);
        }
    ),
    ...generateActionForKey(
        eDmLoaiThuTuyenSinhActionsObj,
        "LOAI_THU_TUYEN_SINH",
        "SAVE_MULTIPLE_SUCCESS",
        () => {
            NotifyHelper.Success("Thành công");
        }
    ),
    ...generateActionForKey(
        eDmLoaiThuTuyenSinhActionsObj,
        "LOAI_THU_TUYEN_SINH",
        "SAVE_MULTIPLE_ERROR",
        (m: string) => {
            NotifyHelper.Error(m ?? "Thất bại");
        }
    ),
};
